import * as React from "react";
import { List, DataTable, SearchInput, NumberField } from "react-admin";

const RestaurantPlanFilter = [<SearchInput source="name" alwaysOn />];

const RestaurantPlanList = () => (
  <List title="Planes Restaurantes" filters={RestaurantPlanFilter}>
    <DataTable bulkActionButtons={false}>
      <DataTable.Col source="name" label="Nombre" />
      <DataTable.Col source="description" label="Descripción" />
      <DataTable.Col source="price" label="Precio">
        <NumberField
          source="price"
          label="Precio"
          options={{ style: "currency", currency: "ARS" }}
        />
      </DataTable.Col>
      {/* <EditButton /> */}
    </DataTable>
  </List>
);

export default RestaurantPlanList;
